import styled from "styled-components";

export const Container = styled.div`
    display: flex !important;
    justify-content: center;
    align-items: center;
    overflow: visible;
    flex-direction: column;
`

export const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`
export const PokeList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 10px;
  gap: 20px; /* Espaciado entre tarjetas */
  overflow-y: scroll;
  max-height: 70vh;
`;

export const PokeItem = styled.div`
  margin: 10px;
`;

export const ItemCard = styled.div`
  //border: 1px solid #ccc;
  padding: 10px;
  border-radius: 10px;
  text-align: center;
  //box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 120px; /* Ajuste de ancho de la tarjeta */
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.05); /* Efecto de hover */
  }
`;

export const PokeImg = styled.img`
  width: 100px;
  height: 100px;
  object-fit: contain;
`;

export const ItemData = styled.div`
  margin-top: 10px;
`;

export const QuantityCircle = styled.div`
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #F4A261;
  color: white;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
`;

export const MinusButton = styled.button`
  position: absolute;
  bottom: -10px;
  right: -10px;
  background-color: #ff4d4f;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    background-color: #ff7875;
  }
`;
